export default "__VITE_ASSET__DYxDTk_R__"